'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dEnvelopes$002dPage$0024 from "./presto.-List-Envelopes-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103 from "./presto.-Presto-Router$$anon$103.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$102() {
  this.be7 = null;
  this.bdZ = null;
  this.be0 = false;
  this.be8 = null;
  this.be9 = false;
  this.bec = null;
  this.be5 = null;
  this.be6 = false;
  this.be1 = null;
  this.be2 = false;
  this.be3 = null;
  this.be4 = false;
  this.bea = false;
  this.beb = false;
  this.be7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bec = "ListEnvelopesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$102 as $c_Lpresto_PrestoRouter$$anon$102 };
$p = $c_Lpresto_PrestoRouter$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$102;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$102() {
}
export { $h_Lpresto_PrestoRouter$$anon$102 as $h_Lpresto_PrestoRouter$$anon$102 };
$h_Lpresto_PrestoRouter$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.be7;
});
$p.M = (function() {
  if ((!this.be0)) {
    this.bdZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.be0 = true;
  }
  return this.bdZ;
});
$p.O = (function() {
  if ((!this.be9)) {
    this.be8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.be9 = true;
  }
  return this.be8;
});
$p.D = (function() {
  return this.bec;
});
$p.t = (function() {
  if ((!this.be6)) {
    this.be5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.be6 = true;
  }
  return this.be5;
});
$p.N = (function() {
  if ((!this.be2)) {
    this.be1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.be2 = true;
  }
  return this.be1;
});
$p.Q = (function() {
  if ((!this.be4)) {
    this.be3 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103.$c_Lpresto_PrestoRouter$$anon$103();
    this.be4 = true;
  }
  return this.be3;
});
$p.v = (function() {
  if ((!this.beb)) {
    this.bea = false;
    this.beb = true;
  }
  return this.bea;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee618) => ((p) => \u03b4scrutinee618))($j_presto$002e$002dList$002dEnvelopes$002dPage$0024.$m_Lpresto_ListEnvelopesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$102, "presto.PrestoRouter$$anon$102", ({
  Ny: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$102 as $d_Lpresto_PrestoRouter$$anon$102 };
//# sourceMappingURL=presto.-Presto-Router$$anon$102.js.map
